<aside class="l-sidebar l-flex l-column scroller mCustomScrollbar _mCS_3">
<img class="off-mobile sidebar-logo" src="../../assets/icons/logo.svg" alt="Artisan Sonics" />

		<!-- user panel (start) -->
		<div class="userPanel">
			
			<i class="userPanel-icon icon-female" *ngIf="pat.ID != 'default'">
				<span class="l-flex t-boxMargin menstural-fields-set">
					
					<button class="btn-user_data" aria-label="user data" (click)="showPatD()" matTooltip="Open Patient Details" [ngClass]="! patientsService.getPat().Birth && (examsService.ExamType == 'NT' || examsService.ExamType =='1st') ? 'is-invalid':''"></button>
					<div class="t-validation-message">
						<span>Add Birth day by clicking here</span>
					</div>
				</span> 

			</i>

			<div class="userPanel-userName" *ngIf="pat.ID != 'default'">
				{{pat.First}} {{pat.Last}}
			</div>

			<dl class="l-table userPanel-userInfo" *ngIf="pat.ID != 'default'">
				<div class="l-row">
					<dt class="l-td-m">ID Number</dt>
					<dd class="l-td-m">{{pat.ID}}</dd>
				</div>
				<div class="l-row">
					<dt class="l-td-m">Age</dt>
					<dd class="l-td-m">{{patientsService.getAgeMo()}}</dd>
				</div>
				<div class="l-row" style='font-size: 1.2em' *ngIf="examsService.ExamType != 'Gynecology' && examsService.ExamType != 'Follicles' && !loginService.isCardio && !loginService.isGastro">
					<dt class="l-td-m" >GA (at exam)</dt>
					<dd class="l-td-m">{{examsService.examGA()}}</dd>
				</div>
			</dl>

			<div class="userPanel-controls">
				<a  (click)="bookmark()" class="userPanel-controls-item icon-files" [ngClass]="isBookmark ? 'saved' : ''" aria-label="files" matTooltip="Show Previous Exams in a Window"></a>
				<a (click)="handleClose('/exams')" class="userPanel-controls-item icon-exit" aria-label="exit" matTooltip="Close Exam and Open Patient History"></a>
			</div>

		</div>
		<!-- user panel (end) -->

		<!-- main nav (start) -->
		<nav class="mainNav l-fg1">
			<ul class="mainNav-list">
				
			
			

			<ng-container *ngIf="loginService.isCardio && examsService.ExamType !='Consultation Letter' && examsService.ExamType!='Pulmonary functional assessment' && examsService.ExamType!='Methacholine test'">
				<li class="mainNav-item" (click)="setPage('Introduction')">
					<span class="mainNav-link" [ngClass]="currentPage == 'Introduction' ? 'is-active':''">
						Introduction
					</span>
				</li>
				<li class="mainNav-item" (click)="setPage('2D Measurements')" *ngIf="examsService.ExamType !='Stress' && examsService.ExamType !== 'Holter ECG' && examsService.ExamType !='Duplex Carotid'">
					<span class="mainNav-link" [ngClass]="currentPage == '2D Measurements' ? 'is-active':''">
						2D Measurements
					</span>
				</li>
				<li class="mainNav-item" (click)="setPage('Doppler')" *ngIf="examsService.ExamType !='Stress' && examsService.ExamType !== 'Holter ECG' && examsService.ExamType!='Duplex Carotid'">
					<span class="mainNav-link" [ngClass]="currentPage == 'Doppler' ? 'is-active':''">
						Valves and Doppler
					</span>
				</li>
				<li class="mainNav-item" (click)="setPage('Tissue Doppler')" *ngIf="examsService.ExamType !='Stress' && examsService.ExamType !== 'Holter ECG' && examsService.ExamType!='Duplex Carotid'">
					<span class="mainNav-link" [ngClass]="currentPage == 'Tissue Doppler' ? 'is-active':''">
						Heart Function
					</span>
				</li>
				<li class="mainNav-item" (click)="setPage('Findings')" *ngIf="examsService.ExamType != 'TTE Adults' && examsService.ExamType != 'TTE Pediatric' && examsService.ExamType!='Duplex Carotid'" >
					<span class="mainNav-link" [ngClass]="currentPage == 'Findings' ? 'is-active':''">
						{{examsService.ExamType !='Stress-Echo' ? 'Findings' : 'Exercise'}}
					</span>
				</li>
			</ng-container>
			<ng-container *ngIf="examsService.ExamType=='Pulmonary functional assessment' || examsService.ExamType=='Methacholine test'">
				<li class="mainNav-item" (click)="setPage('Introduction')">
					<span class="mainNav-link" [ngClass]="currentPage == 'Introduction' ? 'is-active':''">
						{{examsService.ExamType}}
					</span>
				</li>
			</ng-container>
			
			<li class="mainNav-item" (click)="setPage('Procedure')" *ngIf="examsService.ExamType == 'Amniocentesis' || examsService.ExamType == 'CVS' || examsService.ExamType == 'Follicles'">
				<span class="mainNav-link" [ngClass]="currentPage == 'Procedure' ? 'is-active':''">
					Course of Exam
				</span>
			</li>	
				<li class="mainNav-item" (click)="setPage('Summary')" *ngIf="! examsService.isForm && examsService.ExamType != 'Emergency Room' && ! loginService.isGastro && examsService.ExamType!='Pulmonary functional assessment' && examsService.ExamType!='Methacholine test'">
					<span class="mainNav-link" [ngClass]="currentPage == 'Summary' ? 'is-active':''">
						{{examsService.ExamType == 'Duplex Carotid' ? 'Findings and Diagnosis': 'Summary'}}
					</span>
				</li>				
			</ul>
		</nav>
		<!-- main nav (end) -->

		<app-docpanel></app-docpanel>
		

